import { Chat, LocalPhone, MarkAsUnread } from "@mui/icons-material";
import { Box, Card, CardContent, Typography } from "@mui/material";
import type { HelpMenuItemProps } from "@types_def/components/helpMenuItem";
import { HelpMenuItemType } from "@types_def/components/helpMenuItem";

const zendDeskUrl = import.meta.env.VITE_APP_ZENDESK_URL;

function HelpMenuItem({ method, type, contactInfo, responseTime }: HelpMenuItemProps) {
  const RenderIcon = () => {
    switch (type) {
      case HelpMenuItemType.CHAT:
        return <Chat />;
      case HelpMenuItemType.EMAIL:
        return <MarkAsUnread />;
      case HelpMenuItemType.PHONE:
        return <LocalPhone />;
      default:
        return null;
    }
  };

  const contactUrl = () => {
    switch (type) {
      case HelpMenuItemType.CHAT:
        return zendDeskUrl;
      case HelpMenuItemType.EMAIL:
        return `mailto:${contactInfo}`;
      case HelpMenuItemType.PHONE:
        return `tel:${contactInfo}`;
      default:
        return "";
    }
  };

  return (
    <Card
      component="a"
      href={contactUrl()}
      target="_blank"
      rel="noreferrer"
      sx={{
        textDecoration: "none",
        color: "inherit",
        width: "100%",
        maxWidth: 500,
        minWidth: 300,
        padding: "30px",
        margin: "0 auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        boxShadow: 2,
        borderRadius: 2,
      }}
    >
      <CardContent sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 1 }}>
        <Typography fontWeight="bold" textAlign="center">
          {method}
        </Typography>

        <Box display="flex" alignItems="center" gap={1} fontSize={20} fontWeight={700}>
          <RenderIcon />
          {contactInfo}
        </Box>

        <Typography fontSize="0.9rem" textAlign="center">
          {responseTime}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default HelpMenuItem;
